import { render, staticRenderFns } from "./TdWebImportConfigDetails.vue?vue&type=template&id=7d403f01&scoped=true"
import script from "./TdWebImportConfigDetails.vue?vue&type=script&lang=ts"
export * from "./TdWebImportConfigDetails.vue?vue&type=script&lang=ts"
import style0 from "./TdWebImportConfigDetails.vue?vue&type=style&index=0&id=7d403f01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d403f01",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/td-web-import-config-details.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2FTdWebImportConfigDetails.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports